import {
  COMPANY_NOTIFICATION_RULES_SET_LOADING,
  COMPANY_NOTIFICATION_RULES_SET_ERROR,
  COMPANY_NOTIFICATION_RULES_SET_RULES,
  COMPANY_NOTIFICATION_RULES_SET_TYPES,
  COMPANY_NOTIFICATION_RULES_FETCH_RULES,
  COMPANY_NOTIFICATION_RULES_CREATE_RULE,
  COMPANY_NOTIFICATION_RULES_UPDATE_RULE,
  COMPANY_NOTIFICATION_RULES_DELETE_RULE,
  COMPANY_NOTIFICATION_RULES_CLEAR_ERROR,
  COMPANY_NOTIFICATION_RULES_FETCH_TYPES,
  COMPANY_NOTIFICATION_RULES_GET_RULES,
  COMPANY_NOTIFICATION_RULES_GET_TYPES,
  COMPANY_NOTIFICATION_RULES_GET_LOADING,
  COMPANY_NOTIFICATION_RULES_GET_ERROR
} from './types';
import { notificationRuleService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  rules: [],
  types: [],
  ...createAsyncState([
    'fetchRules',
    'createRule',
    'updateRule',
    'deleteRule',
    'fetchTypes'
  ])
};

const mutations = {
  ...createAsyncMutations(
    COMPANY_NOTIFICATION_RULES_SET_LOADING,
    COMPANY_NOTIFICATION_RULES_SET_ERROR
  ),
  [COMPANY_NOTIFICATION_RULES_SET_RULES](state, rules) {
    state.rules = rules;
  },
  [COMPANY_NOTIFICATION_RULES_SET_TYPES](state, types) {
    state.types = types;
  }
};

const actions = {
  async [COMPANY_NOTIFICATION_RULES_FETCH_RULES](
    { commit },
    { companyId, companyNotificationTypeId = null }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchRules',
      errorMessage:
        'Ocurrió un error al obtener las reglas de notificación de la empresa',
      asyncOperation: async () => {
        const rules = await notificationRuleService.getCompanyNotificationRules(
          {
            companyId,
            companyNotificationTypeId
          }
        );
        commit(COMPANY_NOTIFICATION_RULES_SET_RULES, rules);
        return rules;
      },
      setLoading: COMPANY_NOTIFICATION_RULES_SET_LOADING,
      setError: COMPANY_NOTIFICATION_RULES_SET_ERROR
    });
  },

  async [COMPANY_NOTIFICATION_RULES_FETCH_TYPES]({ commit }) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchTypes',
      errorMessage: 'Ocurrió un error al obtener los tipos de notificación',
      asyncOperation: async () => {
        const types =
          await notificationRuleService.getCompanyNotificationTypes();
        commit(COMPANY_NOTIFICATION_RULES_SET_TYPES, types);
        return types;
      },
      setLoading: COMPANY_NOTIFICATION_RULES_SET_LOADING,
      setError: COMPANY_NOTIFICATION_RULES_SET_ERROR
    });
  },

  async [COMPANY_NOTIFICATION_RULES_CREATE_RULE](
    { dispatch, commit },
    { companyId, companyNotificationTypeId, groupCompanyId, policyId, emails }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'createRule',
      errorMessage: 'Ocurrió un error al crear la regla de notificación',
      asyncOperation: async () => {
        await notificationRuleService.createCompanyNotificationRule({
          companyId,
          companyNotificationTypeId,
          groupCompanyId,
          policyId,
          emails
        });
        dispatch(COMPANY_NOTIFICATION_RULES_FETCH_RULES, {
          companyId
        });
      },
      setLoading: COMPANY_NOTIFICATION_RULES_SET_LOADING,
      setError: COMPANY_NOTIFICATION_RULES_SET_ERROR
    });
  },

  async [COMPANY_NOTIFICATION_RULES_UPDATE_RULE](
    { dispatch, commit },
    {
      id,
      companyId,
      companyNotificationTypeId,
      groupCompanyId,
      policyId,
      emails
    }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'updateRule',
      errorMessage: 'Ocurrió un error al actualizar la regla de notificación',
      asyncOperation: async () => {
        await notificationRuleService.updateCompanyNotificationRule({
          id,
          companyId,
          companyNotificationTypeId,
          groupCompanyId,
          policyId,
          emails
        });
        dispatch(COMPANY_NOTIFICATION_RULES_FETCH_RULES, {
          companyId
        });
      },
      setLoading: COMPANY_NOTIFICATION_RULES_SET_LOADING,
      setError: COMPANY_NOTIFICATION_RULES_SET_ERROR
    });
  },

  async [COMPANY_NOTIFICATION_RULES_DELETE_RULE](
    { dispatch, commit },
    { id, companyId }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'deleteRule',
      errorMessage: 'Ocurrió un error al eliminar la regla de notificación',
      asyncOperation: async () => {
        await notificationRuleService.deleteCompanyNotificationRule({
          id,
          companyId
        });
        dispatch(COMPANY_NOTIFICATION_RULES_FETCH_RULES, { companyId });
      },
      setLoading: COMPANY_NOTIFICATION_RULES_SET_LOADING,
      setError: COMPANY_NOTIFICATION_RULES_SET_ERROR
    });
  },

  [COMPANY_NOTIFICATION_RULES_CLEAR_ERROR]({ commit }, { type }) {
    commit(COMPANY_NOTIFICATION_RULES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [COMPANY_NOTIFICATION_RULES_GET_RULES]: (state) => state.rules,
  [COMPANY_NOTIFICATION_RULES_GET_TYPES]: (state) => state.types,
  [COMPANY_NOTIFICATION_RULES_GET_LOADING]: (state) => state.loading,
  [COMPANY_NOTIFICATION_RULES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
